/**
 * API pour sofaxis-fonpel-espace-elus
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LocalizedValueOfstring { 
    /**
     * Identifier
     */
    identifier: LocalizedValueOfstring.IdentifierEnum;
    /**
     * Localized message
     */
    message: string;
}
export namespace LocalizedValueOfstring {
    export type IdentifierEnum = 'DEVICE_ISSUE' | 'DOCUMENT_ISSUE' | 'NETWORK_ISSUE' | 'TECHNICAL_ISSUE' | 'USER_ISSUE';
    export const IdentifierEnum = {
        DeviceIssue: 'DEVICE_ISSUE' as IdentifierEnum,
        DocumentIssue: 'DOCUMENT_ISSUE' as IdentifierEnum,
        NetworkIssue: 'NETWORK_ISSUE' as IdentifierEnum,
        TechnicalIssue: 'TECHNICAL_ISSUE' as IdentifierEnum,
        UserIssue: 'USER_ISSUE' as IdentifierEnum
    };
}


